module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-panneauDeroulant">    \r\n    <div class="table_AutresAffectationsRemplacements"></div>\r\n</div>';
}
return __p;
};
